import { Injectable, Signal, signal } from '@angular/core';
import { LocalUser } from '../models/local-user.model';

@Injectable({ providedIn: 'root' })
export class UserService {
  private readonly _user = signal<LocalUser | null>(null);

  readonly user: Signal<LocalUser | null> = this._user.asReadonly();

  setUser(user: LocalUser): void {
    this._user.set(user);
  }

  clearUser(): void {
    this._user.set(null);
  }

  hasRole(
    role: keyof Pick<
      LocalUser,
      'isCreator' | 'isReviewer' | 'isOwner' | 'isClaimOwner' | 'isSupplier' | 'isAdmin'
    >,
  ): boolean {
    return this._user()?.[role] ?? false;
  }
}
